<svg xmlns="http://www.w3.org/2000/svg" width="76.16" height="72.19" viewBox="0 0 76.16 72.19">
  <defs>
    <style>
      .cls-1 {
        fill: #c1c1c1;
        fill-opacity: 0.4;
        stroke: #fff;
        stroke-linecap: square;
        stroke-linejoin: bevel;
        stroke-width: 6px;
        stroke-dasharray: 24 12;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <path id="taxi" class="cls-1" d="M4372,5632l-28,42-44-22,27-45,19,7Z" transform="translate(-4297.84 -5605.53)"/>
</svg>
